export const MARKETING_IMAGE = 'https://headless.expediagroup.com/content/dam/marketing/headless/images/home-page/Home_Hero-Vrbo-LG_ULX_variant.jpg';
export const EMAIL_VERIFICATION_SUCCESS_IMAGE = 'https://headless.expediagroup.com/content/dam/marketing/headless/site-assets/icons/Continue_hotel_onbording_icon.png';

export const HERO_IMAGE_V2 = {
    alt: 'family enjoying cabin vacation',
    url: 'https://headless.expediagroup.com/content/dam/marketing/headless/images/home-page/VRSloganHero.webp',
    mobileSrc:
    'https://headless.expediagroup.com/content/dam/marketing/headless/images/home-page/VrSloganheromobile.webp'
};

export default {
    MARKETING_IMAGE,
    HERO_IMAGE_V2,
    EMAIL_VERIFICATION_SUCCESS_IMAGE
};
